import { render, staticRenderFns } from "./canyinDetail.vue?vue&type=template&id=f6f60066&scoped=true&"
import script from "./canyinDetail.vue?vue&type=script&lang=js&"
export * from "./canyinDetail.vue?vue&type=script&lang=js&"
import style0 from "./canyinDetail.vue?vue&type=style&index=0&id=f6f60066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f60066",
  null
  
)

export default component.exports